// 用户管理页：快捷搜索 / 高级筛选字段配置
export const normalizeOptions = (options = []) => {
  // 统一为 { label, value }，兼容接口与静态数据两种来源
  return options.map(item => ({
    label: item.label ?? item.name ?? item.display_name ?? item.id ?? '',
    value: item.value ?? item.id ?? ''
  }))
}

const createUserSearchFields = ({
  t,
  roleOptions = [],
  tenantOptions = []
}) => {
  return {
    username: {
      key: 'username',
      label: t('user.userName'),
      filterType: 'filter',
      type: 'input',
      value: '',
      defaultValue: '',
      trim: true,
      placeholder: t('placeholder.search'),
      clearable: true
    },
    filter_email: {
      key: 'filter_email',
      label: t('user.email'),
      filterType: 'filter',
      type: 'input',
      value: '',
      defaultValue: '',
      trim: true,
      placeholder: t('placeholder.search'),
      clearable: true
    },
    user_ids: {
      key: 'user_ids',
      label: t('user.user_id'),
      filterType: 'filter',
      type: 'input',
      value: '',
      defaultValue: '',
      trim: true,
      placeholder: t('placeholder.search'),
      clearable: true
    },
    roles: {
      key: 'roles',
      label: t('user.role'),
      filterType: 'filter',
      type: 'select',
      value: '',
      defaultValue: '',
      options: normalizeOptions(roleOptions),
      placeholder: t('placeholder.choose'),
      clearable: true
    },
    enterprise_id: {
      key: 'enterprise_id',
      label: t('user.tenant'),
      filterType: 'filter',
      type: 'select',
      value: '',
      defaultValue: '',
      options: normalizeOptions(tenantOptions),
      placeholder: t('placeholder.choose'),
      clearable: true,
      filterable: true
    },
    scene: {
      key: 'scene',
      label: t('license.scene'),
      filterType: 'filter',
      type: 'select',
      value: '',
      defaultValue: '',
      options: [
        {
          label: t('license.dr'),
          value: 'dr'
        },
        {
          label: t('license.migration'),
          value: 'migration'
        }
      ],
      placeholder: t('placeholder.choose'),
      clearable: true
    },
    status: {
      key: 'status',
      label: t('table.status'),
      filterType: 'filter',
      type: 'select',
      value: '',
      defaultValue: '',
      options: [
        {
          label: t('user.enabled'),
          value: 'enabled'
        },
        {
          label: t('user.disabled'),
          value: 'disabled'
        }
      ],
      placeholder: t('placeholder.choose'),
      clearable: true
    }
  }
}

/** 快捷搜索：左侧下拉选字段，右侧单字段输入/选择 */
export const createUserQuickSearchFields = (params) => createUserSearchFields(params)

/** 高级筛选抽屉：支持多字段组合 */
export const createUserAdvancedFilterCondition = (params) => createUserSearchFields(params)

export const createUserAdvancedOtherConditionList = () => ({})
